import { inject, Injectable, Signal } from "@angular/core";
import { CONFIGURATION_SERVICE } from "@core/system-configuration";
import { selectLogoutUrl, UserState } from "@features/user";
import "@extensions/string-extensions";
import { Store } from "@ngrx/store";
import { clearSessionStorage } from "@utility/storage";

@Injectable({
	providedIn: "root"
})
export class AuthService {
	private readonly systemConfigurationService = inject(CONFIGURATION_SERVICE);
	private readonly userStore = inject(Store<UserState>);

	private readonly logoutUrl$!: Signal<string>;

	constructor() {
		this.logoutUrl$ = this.userStore.selectSignal(selectLogoutUrl);
	}

	public redirectUserToLogin(): void {
		const url = this.systemConfigurationService.getApiEndpoint(
			`/bff/login?returnUrl=${globalThis.window.location.href}`
		);
		globalThis.window.location.href = url;
	}

	public redirectToChangePassword(email: string): void {
		const url = this.systemConfigurationService.getApiEndpoint(
			`/bff/change-password?email=${encodeURIComponent(email)}&returnUrl=${encodeURIComponent(globalThis.window.location.href)}`
		);
		globalThis.window.location.href = url;
	}

	public logout(): void {
		clearSessionStorage();

		if (this.logoutUrl$().isWhitespace()) {
			this.redirectUserToLogin();
		} else {
			const url = this.systemConfigurationService.getApiEndpoint(this.logoutUrl$());
			globalThis.window.location.href = url;
		}
	}
}
